import { render, staticRenderFns } from "./CatalogoProdutos.vue?vue&type=template&id=0aff310a&scoped=true"
import script from "./CatalogoProdutos.vue?vue&type=script&lang=js"
export * from "./CatalogoProdutos.vue?vue&type=script&lang=js"
import style0 from "./CatalogoProdutos.vue?vue&type=style&index=0&id=0aff310a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aff310a",
  null
  
)

export default component.exports